import { Chip } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledChip = styled(Chip) `
  width: fit-content;
`;
